import React from 'react'
import imgUrl from '../assets/images/imgUrl'
import {
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Button,
  Box,
  Typography,
} from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const countries = ["Country","USA", "India", "UK", "Germany", "Australia"];

function Contact() {
  return (
    <div className='homeMainWrapper biographyWrapper awardsWrapper thoughtLeadershipwrapper eventsWrapper contactWrapper'>
      <div className='homeBackground'>
            <div className='upperImage'>
            <img src={imgUrl.smileLogo} alt='smile logo'></img>
            </div>
      </div>

      {/* contact form */}

      <Box className="d-flex-align-center-justify-center">
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid size={12} className="homeSections">
            <div className='coloredBoxes mt-30px'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>
            <Typography className='headings sectionHeading blackTitles'>Contact Form</Typography>
          </Grid>
        </Grid>
      </Box>
      {/* contact form section box */}
      <Box
        sx={{
          backgroundColor: "#f2f2f2",
          padding: 4,
          maxWidth: 600,
          margin: "0 auto",
          borderRadius: 2,
        }}
        className="contactMainSection mb-40px"
        mt={5}
      >
        <form className="contactForm">
            <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
                <TextField fullWidth label="" placeholder="First Name" variant="outlined" size="small" />
            </Grid>

             <Grid size={{ xs: 12, md: 6 }}>
                <TextField fullWidth label="" placeholder="Last Name" variant="outlined" size="small" />
             </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
                <FormControl fullWidth className='countryLabel'>
                <Select defaultValue="Country" size="small">
                {countries.map((country, i) => (
                <MenuItem key={i} value={country} disabled={country === "Country"}>
                    {country}
                </MenuItem>
                ))}
                </Select>
                </FormControl>

            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
                <TextField fullWidth label="" placeholder="Mobile (optional)" variant="outlined" size="small"/>
            </Grid>

            <Grid size={12}>
                <TextField fullWidth label="" placeholder="Email" variant="outlined" size="small" />
            </Grid>

            <Grid size={12}>
                <TextField fullWidth label="" placeholder="Subject" variant="outlined" size="small" />
            </Grid>

            <Grid size={12}>
                <TextField fullWidth placeholder="Message"  multiline rows={4} variant="outlined" size="small" />
            </Grid>

            <Grid size={12} textAlign="center">
                <Button
                type="submit"
                variant="contained"
                sx={{
                    color: "#fff",
                    borderRadius:"50px",
                    fontWeight:"bold",
                    px: 3,
                    textTransform:"capitalize",
                    fontSize:"20px"
                }}
                className="contactSubmitButton"
                >
                SUBMIT
                </Button>
            </Grid>
            </Grid>

        </form>
      </Box>

      {/* connect on social meadia section */}

      <section>
         <div className='dynamicBannerwrapper lifeStoryWrapper p-40px d-flex-align-center-justify-center flex-direction-column'>
            <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>
            
             <div className='iconBackground'>
                <img src={imgUrl.connect} alt='icon'></img>
             </div>
            
             <Typography className='headings sectionHeading blackTitles lifeStorytitle'>Connect on Social Media</Typography>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
                Join <b> Dr. Huzaifa Khorakiwala’s </b> community online and stay updated
                through social media. You can follow his official social media pages for
                regular updates, inspirational posts and interactive content:
             </Typography>

             <Grid container spacing={2} className="connectSocialsection">
              <Grid size={{ xs: 4, sm:4, md: 4, lg:4 }}>
                <a
                href="https://www.facebook.com/huzaifa.khorakiwala" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className='iconBackground iconYellowbg'>
                <img src={imgUrl.facebook} alt='icon'></img>
                </div>
                </a>
              </Grid>

              <Grid size={{ xs: 4, sm:4, md: 4, lg:4 }}>
                <a
                href="https://www.instagram.com/dr.huzaifa_khorakiwala/" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
             <div className='iconBackground'>
                <img src={imgUrl.instagram} alt='icon'></img>
             </div>
            
                </a>
              </Grid>

              <Grid size={{ xs: 4, sm:4, md: 4, lg:4 }}>
                 <a
                href="https://www.linkedin.com/in/huzaifakhorakiwala/" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className='iconBackground iconYellowbg'>
                <img src={imgUrl.linkedin} alt='icon'></img>
                </div>
                 </a>
              </Grid>
             </Grid>

             <div className='tapToknow'>
                <Typography>Tap to Connect</Typography>
                <img src={imgUrl.tapIcon}></img>
             </div>
         </div>
      </section>

      {/* facebook section */}

      {/* <section>
         <div className='whiteSection lifeStoryWrapper publicationWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>
            <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>
                
                <a
                href="https://www.facebook.com/huzaifa.khorakiwala" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className='iconBackground iconYellowbg'>
                <img src={imgUrl.facebook} alt='icon'></img>
                </div>
            
            <div className='socialIcons'>
            <Typography className='headings sectionHeading sectionShorttitle'>Facebook</Typography>
            <OpenInNewIcon />
            </div>
            </a>


            <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
                Connect on the official Facebook page (Global Justice, Love & Peace Summit) for event updates, live streams and <br/>
                messages from <b> Dr. Khorakiwala. </b>
            </Typography>
         </div>
      </section> */}

      {/* instagram section */}

      {/* <section>
        <div className='dynamicBannerwrapper lifeStoryWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>
            
             <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>
            
             <a
                href="https://www.instagram.com/dr.huzaifa_khorakiwala/" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
             <div className='iconBackground'>
                <img src={imgUrl.instagram} alt='icon'></img>
             </div>
            
             <div className='socialIcons'>
             <Typography className='headings sectionHeading blackTitles lifeStorytitle sectionShorttitle'>Instagram</Typography>
              <OpenInNewIcon />
             </div>
             </a>
              <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
                Follow on Instagram to see snapshots of ground-level work, behind-the-scenes moments <br/>
                and motivational quotes.

              </Typography>
        </div>
      </section> */}

      {/* linkedin section */}

       {/* <section>
      <div className='whiteSection lifeStoryWrapper publicationWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>
         <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>

                 <a
                href="https://www.linkedin.com/in/huzaifakhorakiwala/" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className='iconBackground iconYellowbg'>
                <img src={imgUrl.linkedin} alt='icon'></img>
                </div>
            
            <div className='socialIcons'>
            <Typography className='headings sectionHeading sectionShorttitle'>LinkedIn</Typography>
             <OpenInNewIcon />
            </div>
            </a>

            <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
                Follow the LinkedIn page for professional updates, articles and network opportunities . <b> Dr. Khorakiwala </b> often shares <br/>
                thought leadership content here aimed at professionals and CSR leaders.
            </Typography>
      </div>
       </section> */}


      {/* youtube section */}

    <section>
        <div className='dynamicBannerwrapper lifeStoryWrapper p-40px d-flex-align-center-justify-center flex-direction-column whiteSection'>
             <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>

               <a
                href="https://www.youtube.com/@IAMPEACEKEEPER" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
            
             <div className='iconBackground iconYellowbg'>
                <img src={imgUrl.youtube} alt='icon'></img>
             </div>
            
            <div className='socialIcons'>
             <Typography className='headings sectionHeading blackTitles lifeStorytitle sectionShorttitle'>YouTube</Typography>
              <OpenInNewIcon />
            </div>
              </a>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
                Subscribe to the <b> YouTube </b> channel to watch speeches, interviews and
                documentaries related to his initiatives. Video content ranges from short
                inspiration clips to full-length panel discussions and musical peace
                anthems from events
             </Typography>

        </div>
    </section>

    {/* join conversation section */}
    <section>
        <div className='dynamicBannerwrapper  lifeStoryWrapper publicationWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>
            <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>

                <div className='iconBackground '>
                <img src={imgUrl.conversation} alt='icon'></img>
                </div>

            <Typography className='headings sectionHeading sectionShorttitle'>Join the Conversation
            </Typography>

            <Typography className='sectionHeading blackTitles detailedPersonalinfo'>
                Use hashtags like <b> #IAmPeacekeeper, #GlobalPeace </b> or
                <b> #WockhardtFoundation  </b>when posting about related causes or events. <b> Dr.
                Khorakiwala’s  </b> movements thrive on community engagement, so your
                social media voice is welcome in this growing chorus for good.
            </Typography>

            <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-20px'>
                Finally, whether you reach out through a form, a phone call or a social
                media comment, rest assured that your message matters. <b> Dr.
                Khorakiwala’s  </b> endeavour is built on collaboration and collective effort –
                together, as he often says, we can ensure that every smile counts and
                peace prevails. Thank you for visiting the site and for your interest in connecting and contributing to these causes.
            </Typography>

            <Typography className='headings sectionHeading officeText blackTitles'>– FROM THE GLOBAL BUREAU HEADQUARTERS OF DR. HUZAIFA KHORAKIWALA
            </Typography>

        </div>
    </section>

      

    </div>
  )
}

export default Contact
